import type { UserEventWrapper } from './events-wrapper.js';

type CliCommand = 'dev' | 'build' | 'preview';

export interface HookPayloadsMap {
  'cli:setup': { cmd: CliCommand };
}

interface UserHooksMap extends HookPayloadsMap {
  'cli:setup': { cmd: CliCommand; emitter: UserEventWrapper };
}

export const USER_HOOK_NAMES = ['cli:setup'] as const satisfies ReadonlyArray<
  keyof HookPayloadsMap
>;

// Compile-time guard: fails if a key of `UserHooksMap` is missing from `USER_HOOK_NAMES` above.
type AssertTrue<T extends true> = T;

type _UserHookNamesAreExhaustive = AssertTrue<
  keyof HookPayloadsMap extends (typeof USER_HOOK_NAMES)[number] ? true : false
>;

export type UserHooksHandlers = {
  [K in keyof UserHooksMap]?: (data: UserHooksMap[K]) => void | Promise<void>;
};
